export default __webpack_public_path__ + "static/media/case-study-left.3293336d.png";